import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {CustomersService} from "app/services";
import {toggleQuickPanel} from "app/main/shared-components/quick-panel/store";
import {errorMsg, successMsg} from "app/utils/MessageUtils";
import {fetchAllCustomers} from "./customers-list.slice";


interface ActivateCustomerStateParams {
    id: string;
    onSuccess?: Function;
    onError?: Function;
}

export const activateCustomer = (params: ActivateCustomerStateParams) => async (dispatch: Dispatch) => {
    try {
        dispatch(setLoading(true));
        const response = await CustomersService.activateCustomer(params.id);
        if (response.status >= 200 && response.status < 300) {
            dispatch(setSuccess(true));
            dispatch(successMsg(localStorage.getItem('i18nextLng') === 'en' ? 'Customer activated successfully!' : 'Klienti u aktivizua me sukses!'));
            if (params.onSuccess) params.onSuccess();
            dispatch(setError(""));
// @ts-ignore
            dispatch(fetchAllCustomers());
        }
        dispatch(setLoading(false));
    } catch (err) {
        dispatch(setLoading(false));
        dispatch(errorMsg(err.data.message));
        if (params.onError) params.onError();
        dispatch(setError(err.data.message));
    }
};


interface CreateCustomerSlice {
    success: boolean;
    error: string;
    loading: boolean;
}

const initialState: CreateCustomerSlice = {
    error: '',
    success: false,
    loading: false
}

const stateSlice = createSlice({
    name: 'customer/activate-customer',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setSuccess: (state, action) => {
            state.success = action.payload
        },
        setError: (state, action) => {
            state.error = action.payload
        }
    }
})

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;